import { Shield } from 'lucide-react';

interface RdScopeBannerProps {
  regionName: string;
  manageableCount: number;
}

/** "Scoped to <region>" banner above the table when the viewer is a
 *  Regional Director. Visual reinforcement of server-side scoping. */
export default function RdScopeBanner({ regionName, manageableCount }: RdScopeBannerProps) {
  return (
    <div className="flex-none bg-white dark:bg-[#1a1f1c] border border-moss-200 rounded-xl px-4 py-3 flex items-center gap-3">
      <div className="w-8 h-8 rounded-lg bg-[#EAF3DE] text-moss-700 flex items-center justify-center">
        <Shield size={16} />
      </div>
      <div className="flex-1">
        <div className="text-[13px] font-bold text-bark-900 dark:text-[#e8ece9]">
          Scoped to {regionName}
          <span className="font-medium text-stone-600 dark:text-stone-400">
            {' '}
            · {manageableCount} user{manageableCount === 1 ? '' : 's'} you manage
          </span>
        </div>
        <div className="text-[11.5px] text-stone-600 dark:text-stone-400 mt-0.5 leading-snug">
          You can invite and edit Instructors within your region. Other roles, and users outside
          this region, are managed by Ops.
        </div>
      </div>
    </div>
  );
}
